import { render } from "./AppLayout.vue?vue&type=template&id=23ee05fd"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=23ee05fd&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__